//通用性组件自定义验证方法封装
//验证方法对象
// 身份证验证
const userIDCard = (rule, value, callback) => {
  const IDCardReg = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[0-2])(([0-2][1-9])|10|20|30|31)\d{3}(\d|X|x)$/
  // const sfzhReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
  if (value) {
    if (IDCardReg.test(value)) {
      callback()
    } else {
      callback(new Error('身份证号格式不正确'))
    }
  } else {
    callback()
  }
}
// 设置网址链接的验证规则
const isTrueUrl = (rule, value, callback) => {
  if (value) {
    let reg = /(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/
    if (!reg.test(value)) {
      callback(new Error('请输入正确的链接'))
    } else {
      callback()
    }
  }else {
    callback()
  }
}
// 设置手机号的验证规则
const phone = (rule, value, callback) => {
  if (value) {
    // 判断当输入的有值时，才校验
    if (!(/^1[3456789]\d{9}$/.test(value))) {
      callback(new Error('手机号格式不正确'))
    } else {
      callback()    // 注意这里要回调一下，不然提交不了
    }
  } else {
    callback()
  }
}

const rulesList = {
  // 系统的必填通用验证
  rules:{
      required: true,
      message: "必填项，请填写内容",
      trigger: "blur"
    },

  //验证数字类型，但非必填验证
  rulesnumber: {
    type: 'number',
    message: '必须为数字值或空值',
    transform(value) {
      if (value) {
        return Number(value)
       }
    }
  },

  //验证网址链接，但非必填验证
  rulesurl: {
    validator: isTrueUrl,
    trigger:'blur'
  },

  //验证身份证号
  rulesidcard: {
    validator: userIDCard,
    trigger:'blur'
  },


  //验证手机号，但非必填验证
  rulesphone: {
    validator: phone,
    trigger: "blur"
  },

  //验证邮箱,但非必填验证
  rulesemail: {
    type: 'email',
    message: '请输入正确的邮箱地址',
    trigger: ['blur', 'change']
  },
//验证英文字母值，但非必填验证
  ruleseng: {
      validator: function (rule, value, callback) {
        if (/^[A-Za-z]+$/.test(value) == false&&value) {
          callback(new Error("必须为英文字母值"));
        } else {
          //校验通过
          callback();
        }
      },
      trigger: ['blur', 'change']
    },
//验证英文字母值，和数字或空值，但非必填验证
  rulesengnum: {
    validator: function (rule, value, callback) {
      const regex = /^[a-zA-Z0-9]+$/;
      if (!regex.test(value)&&value){
        callback(new Error("必须为英文字母或数字值"));
      } else {
        //校验通过
        callback();
      }
    },
    trigger: ['blur', 'change']
  },

}
export default {
//验证方法根据传入key值返回对应验证
  getrules(type) {
    return rulesList[type]
  },
}
